import * as React from "react";


import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Button } from "../../../../../../../react-core/Html/Button";

interface IPayeEstimate {
    data: any;
    onClick: () => void;
    labels: any;
    messages: any;
}
const PayeEstimate = ({data, onClick, labels, messages}: IPayeEstimate) =>{
    
    return (
        <div className="w-500">
            <Button
                className="button mb-20"
                type="button"
                onClick={()=>{}}
            >
                {labels.calculateEstimatedPaye}
            </Button>
            <div className="col-10 mt-10 mb-10 pt-15 pr-15 pb-15 pl-15" style={{backgroundColor: "rgba(0,0,0,0.05)"}}>
                <div className="row">
                    <span className="col-8 text-bold">{labels.estimatedPayeTax}</span>
                    <span className="col-4 h4" data-test="estimatedPayeTax">{MoneyDisplayHelper.FromatMoneyDisplay(
                        data?.EstimatedPayeTax?.Amount,
                        data?.EstimatedPayeTax?.Currency || CurrencyCode.GBP
                    )}
                    </span>
                </div>
                <div className="row">
                    <span className="col-8 text-bold">{labels.estimatedNetPayment}</span>
                    <span className="col-4 h4" data-test="estimatedNetPayment">{MoneyDisplayHelper.FromatMoneyDisplay(
                        data?.EstimatedNetPayment?.Amount,
                        data?.EstimatedNetPayment?.Currency || CurrencyCode.GBP
                    )}</span>
                </div>
                <div className="row">
                    <span className="col-8 text-bold">{labels.taxCode}</span>
                    <span className="col-4 h4" data-test="taxCode">{data?.TaxCode}</span>
                </div>
                <div className="row">
                    <span className="col-8 text-bold">{labels.taxBasis}</span>
                    <span className="col-4 h4" data-test="taxBasis">{data?.TaxBasis}</span>
                </div>
            </div>
        </div>
    );
}

export default PayeEstimate;